import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Data {
    projectId: string;
}
interface Options {
    onSuccess?: (data: Data) => void;
}

interface Input {
    projectId: string;
}

export function useReviseProjectMutation(chatId: string, options?: Options) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ projectId }: Input) => {
            const res = await apiClient.reviseProject({
                params: { id: projectId },
                body: {
                    createProjectChatId: chatId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to revise project");
            }
            await queryClient.invalidateQueries({
                queryKey: ["project", projectId],
            });
            return {
                projectId,
            };
        },
        onSuccess: options?.onSuccess,
    });
}
